"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (obj, predicate) {
    return Object.keys(obj).reduce(function (acc, key) {
        if (predicate(obj[key])) {
            acc[key] = obj[key];
        }
        return acc;
    }, {});
};


//////////////////
// WEBPACK FOOTER
// ./~/binary-utils/lib/object/filterDeep.js
// module id = 108
// module chunks = 0